import clsx from "clsx";
import makeStyles from "@mui/styles/makeStyles";
import { palette } from "../../../theme/palette";
import { OWNERSHIP } from "../../../consts/strings";
import { View } from "../../Base";

const useStyles = makeStyles({
  toggleContainer: {
    display: "flex",
    width: "5.2rem",
    borderRadius: "0.8rem",
    boxShadow: "rgb(0 0 0 / 50%) 0px 1px 4px",
    cursor: "pointer",
  },
  toggleCircle: {
    background: palette.white,
    margin: "0.05rem 0.15rem",
    height: "1.5rem",
    width: "1.5rem",
    borderRadius: "50%",
    boxShadow: "rgb(0 0 0 / 80%) 0px 1px 4px",
  },
  toggleValueLabelContainer: {
    display: "flex",
    flex: 1,
    padding: "0.1rem 0.3rem",
    pointerEvents: "none",
    userSelect: "none",
  },
  toggleFullValueLayout: {
    flexDirection: "row-reverse",
  },
});

export const EditPickupPartnerToggle = ({ routeEdit, onEdit, value }) => {
  const styles = useStyles();

  const toggleBackgroundStyles = {
    [OWNERSHIP.ALL]: { background: routeEdit.colour },
    [OWNERSHIP.SOME]: {
      background: `repeating-linear-gradient(135deg, ${routeEdit.colour} 0px, ${routeEdit.colour} 10px, ${palette.veryLightGrey} 10px, ${palette.veryLightGrey} 20px)`,
    },
    [OWNERSHIP.NONE]: { background: palette.veryLightGrey },
  };

  return (
    <View
      className={clsx(
        styles.toggleContainer,
        value === OWNERSHIP.ALL && styles.toggleFullValueLayout
      )}
      style={toggleBackgroundStyles[value]}
      onClick={onEdit}
    >
      <View className={styles.toggleCircle} />
      <View
        className={clsx(
          styles.toggleValueLabelContainer,
          value === OWNERSHIP.ALL && styles.toggleFullValueLayout
        )}
      >
        <View>{value.toLowerCase()}</View>
      </View>
    </View>
  );
};
